import authHeader from "./auth.header"
import constants from "./constants.js"
import { redirectToLogin } from "./session.js"

const HOST_URL = constants.API_URL

const readBody = async (response) => {
    try {
        return await response.json()
    } catch (e) {
        return null
    }
}

const flattenValidation = (body) => {
    const errors = body && (body.errors || body.messages || body.error)
    if (!errors) return (body && body.message) || "Données invalides."
    if (typeof errors === "string") return errors
    return Object.entries(errors)
        .map(([field, msg]) => `${field} : ${Array.isArray(msg) ? msg.join(", ") : msg}`)
        .join("\n")
}

// Always resolves to { ok, data, error, status }; never throws on HTTP errors.
async function request(path, method, payload) {
    let response
    try {
        response = await fetch(`${HOST_URL}${path}`, {
            method,
            headers: {
                Accept: "application/json",
                ...(payload ? { "Content-Type": "application/json" } : {}),
                ...authHeader(),
            },
            ...(payload ? { body: JSON.stringify(payload) } : {}),
        })
    } catch (e) {
        return { ok: false, status: 0, error: "Impossible de joindre le serveur." }
    }

    const body = await readBody(response)
    if (response.ok) return { ok: true, status: response.status, data: body }

    let error
    switch (response.status) {
        case 401:
            redirectToLogin()
            error = "Votre session a expiré. Veuillez vous reconnecter."
            break
        case 403:
            error = "Vous n'avez pas les droits d'administration nécessaires."
            break
        case 404:
            error = "Tarif introuvable."
            break
        case 409:
            error = "Un tarif existe déjà pour cette combinaison nombre de tokens / devise."
            break
        case 422:
            error = flattenValidation(body)
            break
        default:
            error = (body && body.message) || "Une erreur est survenue."
    }
    return { ok: false, status: response.status, error }
}

// Admin list: includes inactive prices (the public GET /payment/ai-tokens/prices only returns active ones).
export async function fetchAllAiTokenPrices() {
    const res = await request("/payment/ai-tokens/prices/all", "GET")
    if (res.ok) {
        const d = res.data
        res.data = Array.isArray(d) ? d : (d && (d.prices || d.data)) || []
    }
    return res
}

export const addAiTokenPrice = (price) => request("/payment/ai-tokens/prices/add", "POST", price)

export const updateAiTokenPrice = (price) => request("/payment/ai-tokens/prices/update", "POST", price)

// Soft delete: sets active to 0.
export const deactivateAiTokenPrice = (id) => request(`/payment/ai-tokens/prices/delete/${id}`, "POST")
